import React from "react";
import "./Styles.css";
import { FaWhatsapp } from "react-icons/fa";
import WellingtonImg from "../../imagens/wellington_sem_fundo.png";

const Cards = () => {
  return (
    <div className="container">
      <div className="cards-container fade-in">

        {/* Painel de Destaque */}
        <div className="highlight-panel">
          <h1>
            Manutenção de Computadores em <span className="highlight">Pilar do Sul</span>
          </h1>
          <p>Formatação, manutenção, upgrade e suporte técnico especializado em PCs e notebooks.</p>
        </div>

        {/* Foto do Wellington */}
        <div className="profile-image">
          <img src={WellingtonImg} alt="Wellington Miranda" />
        </div>

      </div>

      {/* Botão WhatsApp */}
      <div className="whatsapp-button">
        <a
          href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-action"
        >
          <FaWhatsapp className="whatsapp-icon" />
          <span>Fale conosco</span>
        </a>
      </div>
    </div>
  );
};

export default Cards;
